import classes from 'classnames'
import styles from './index.module.css'

const RechartsWrapper = ({ children, className }) => (
  <div className={classes(styles.container, className)}>
    {children}
  </div>
)

export default RechartsWrapper